import {createQueryKeys} from "../../shared/query/query-keys";

/**
 * Typed query key namespace for the users feature.
 *
 * Examples:
 *   userKeys.all                        // ["users"]
 *   userKeys.lists()                    // ["users", "list"]
 *   userKeys.list({ page: 1, perPage: 20 }) // ["users", "list", { ... }]
 *   userKeys.details()                  // ["users", "detail"]
 *   userKeys.detail("u1")              // ["users", "detail", "u1"]
 */
export const userKeys = createQueryKeys("users");

/**
 * Stable mutation key namespace for the users feature.
 *
 * Mutation keys enable:
 *  - DevTools inspection (mutations shown by key in the TanStack Query Devtools)
 *  - `queryClient.setMutationDefaults(...)` targeting for per-mutation overrides
 *
 * Examples:
 *   userMutationKeys.all                  // ["users", "mutation"]
 *   userMutationKeys.update()             // ["users", "mutation", "update"]
 *   userMutationKeys.delete()             // ["users", "mutation", "delete"]
 */
export const userMutationKeys = {
  all: ["users", "mutation"] as const,
  create: () => ["users", "mutation", "create"] as const,
  delete: () => ["users", "mutation", "delete"] as const,
  update: () => ["users", "mutation", "update"] as const,
  addTask: () => ["users", "mutation", "addTask"] as const,
  editTask: () => ["users", "mutation", "editTask"] as const,
  removeTask: () => ["users", "mutation", "removeTask"] as const,
};
